export default "__VITE_ASSET__DEYS24gP__"